import { Button, IconButton, Avatar } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

interface UserButtonProps {
  picture: any;
  recentUser: string;
  onClick: () => void;
}

const UserButton: React.FC<UserButtonProps> = (props: UserButtonProps) => {
  const handleMainClick = () => {
    props.onClick();
  };

  const handleArrowClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    props.onClick();
  };

  return (
    <Button
      onClick={handleMainClick}
      style={{ borderRadius: "90px" }}
      variant="contained"
      sx={{
        textTransform: "none",
        backgroundColor: "#A5EB17",
        color: "black",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        padding: "6px 16px",
        borderRadius: "24px",
        "&:hover": { backgroundColor: "#95D414" },
        minWidth: {
          xs: "425px",
          sm: "425px",
          md: "455px",
        },
        minHeight: "64px",
        fontSize: { sm: "20px", xs: "20px", md: "24px" },
      }}
    >
      <Avatar
        src={props.picture}
        alt="User Avatar"
        sx={{ width: 32, height: 32 }}
      />
      Seguir como <strong>{props.recentUser}</strong>
      <IconButton
        onClick={handleArrowClick}
        sx={{
          border: "3px solid black",
          borderRadius: "50%",
          width: 28,
          height: 28,
          color: "black",
        }}
      >
        <KeyboardArrowDownOutlinedIcon fontSize="medium" />
      </IconButton>
    </Button>
  );
};

export default UserButton;
